module.exports = __webpack_public_path__ + "static/img/client-10.ebf72206.png";